<div *ngIf="isBoReady" class="row ml-3 d-flex">

  <div class="mr-3">
    <div class="q-c-main mb-2">{{fusionStage ? 'Fusionner les données:' : 'Dupliquer les données:'}}</div>
    <ng-container *ngFor="let checkbox of checkBoxes; let i = index">
      <div class="q-check">
        <input type="checkbox" id="check-{{i}}"
               [disabled]="fusionStage != '' && (checkbox.Value == 'RESPONSABLE' || checkbox.Value == 'LIEU' || checkbox.Value == 'RESERVE' || checkbox.Value == 'DEPENSE' || checkbox.Value == 'TACHE')"
               [ngModel]="checkbox.Selected && (!fusionStage || (checkbox.Value != 'RESPONSABLE' && checkbox.Value != 'LIEU' && checkbox.Value != 'RESERVE' && checkbox.Value != 'DEPENSE' || checkbox.Value != 'TACHE' ))"
               (ngModelChange)="checkbox.Selected = $event" />
        <label for="check-{{i}}">
          <span></span>{{checkbox.Label}}
        </label>
      </div>
    </ng-container>
  </div>

  <div placement="bottom">
    <div class="q-c-main mb-2">Fusionner:</div>
    <div> Stage de destination avec le même code produit / action</div>
    <select class="q-main-select" [(ngModel)]="fusionStage">
      <option *ngFor="let option of stages" [value]="option.Value">{{option.Label}}</option>
    </select>
  </div>

</div>

<button *ngIf="isBoReady" class="q-btn q-main m-3" (click)="OnSaveBo(ModalFusion)"><i [ngClass]="[isSaving ? 'fas fa-spin fa-spinner fa-pulse' : 'fas fa-save']" class="mr-1"></i>{{fusionStage ? 'Fusionner les 2 stages' : 'Dupliquer le stage'}}</button>
<ng-container *ngIf="!isBoReady && (!ParamBOStage || !ParamBOStage.model)">
  <div class="row ml-3 d-flex justify-content-center"><i class="fas fa-spin fa-spinner fa-spin q-c-main fa-3x"></i></div>
</ng-container>
<q-bodisplay *ngIf="ParamBOStage && ParamBOStage.model && fusionStage == ''"
             [(save)]="saveBO"
             [param]="ParamBOStage"
             (sendBoReady)="OnBoReady($event)"
             (sendEvent)="OnBoSaved($event)"></q-bodisplay>


<!--  MODAL de validation de la suppression du stage -->
<ng-template #ModalFusion let-modalFusion class="modal-dialog-centered">
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="q-c-main text-center">Etes-vous sûr de vouloir fusionner le stage <br/><strong>{{StageService.Stage.NumStage}} - {{StageService.Stage.Titre}}</strong><br/> et donc de le supprimer définitivement ?</h5>
      <button type="button" class="close" (click)="modalFusion.close('CANCEL');">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="text-center">
      <div>
        <button class="btn q-btn q-danger m-2" type="button" (click)="modalFusion.close('SAVE');"
                title="Fusionner le stage">
          Fusionner
        </button>
      </div>     
    </div>
  </div>
</ng-template>
